import { observable, action } from 'mobx';
import { toast } from "react-toastify";
import IConfiguration from "../../types/IConfiguration";
import IConfigurationService from "../../services/spi/IConfigurationService";
import FirebaseConfigurationService from "../../services/impl/firebase/FirebaseConfigurationService";

const BlankConfiguration = {
  uid: '',
  name: '',
  configCode: "",
  value: "",
  visible: true,
  editable: true,
  deletable: true,
  lastUpdatedOn: '',
};

class ConfigurationStore {
  rootStore: any = null;
  configurationService = {} as IConfigurationService;

  @observable configurations = [] as Array<IConfiguration>;
  @observable configuration: IConfiguration = {
    uid: '',
    name: '',
    configCode: "",
    value: "",
    visible: true,
    editable: true,
    deletable: true,
    lastUpdatedOn: ''
  };

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.configurationService = new FirebaseConfigurationService();
  }

  @action getConfigurations = async () => {
    this.configurations = await this.configurationService.getConfigurations();
  }

  @action setAttribute = (attrName: string, attrValue: string) => {
    switch (attrName) {
      case 'name':
        this.configuration.name = attrValue
        this.configuration.configCode = this.configuration.name.replace(/\s+/g, '-').toUpperCase();
        return;
      case 'value':
        return this.configuration.value = attrValue;
      case 'configCode':
        return this.configuration.configCode = attrValue;
      default:
        return;
    }
  }

  @action setBlankConfiguration = () => {
    this.configuration = BlankConfiguration;
  }

  @action setConfiguration = (data: IConfiguration) => {
    this.configuration = data;
  }

  @action saveConfiguration = async () => {
    const { uid } = this.configuration;
    try {
      if (uid) {
        await this.configurationService.updateConfiguration(this.configuration);
        toast.success("Configuration Updated Successfully!");
      } else {
        await this.configurationService.createConfiguration(this.configuration);
        toast.success("Configuration Added Successfully!");
      }
      this.configurations = await this.configurationService.getConfigurations();
    } catch (err) {
      toast.error("Error Saving Configuration!");
    }
  }

}

export default ConfigurationStore;
